/**
 * Triggers a browser file download from either a URL or a Blob object.
 * @param {string | Blob} source - A URL string or Blob to download
 * @param {string} fileName - The name to give the downloaded file
 */
export const downloadFile = (source, fileName) => {
  const isBlob = source instanceof Blob;
  const url = isBlob ? window.URL.createObjectURL(source) : source;

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  if (isBlob) {
    window.URL.revokeObjectURL(url);
  }
};

/**
 * Handles document download — either direct URL or via blob container.
 * @param {string} uploadedFileName - Display name / download filename
 * @param {string} storedFileName - Stored blob name or direct URL
 * @param {string} containerName - Azure blob container name
 * @param {Function} triggerDownload - RTK Query lazy trigger for blob download
 */
export const handleDocumentDownload = async (uploadedFileName, storedFileName, containerName, triggerDownload) => {
  try {
    if (storedFileName && storedFileName.startsWith("http")) {
      downloadFile(storedFileName, uploadedFileName);
    } else {
      const response = await triggerDownload({
        documentName: storedFileName || uploadedFileName,
        containerName,
      });
      downloadFile(response.data, uploadedFileName);
    }
  } catch (error) {
    console.error(`Error downloading document:`, error);
    throw error;
  }
};
